// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var withDynamic_ = function (dictMonadReplace) {
    var newSlot = Control_Monad_Replace.newSlot(dictMonadReplace);
    return function (dictMonadFRP) {
        var bind = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
        var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
        return function (dyn) {
            return function (widget) {
                return bind(newSlot)(function (slot) {
                    return subscribeDyn_(function (x) {
                        return Control_Monad_Replace.replaceSlot(slot)(widget(x));
                    })(dyn);
                });
            };
        };
    };
};
var dynamic_ = function (dictMonadReplace) {
    var newSlot = Control_Monad_Replace.newSlot(dictMonadReplace);
    return function (dictMonadFRP) {
        var bind = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
        var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
        return function (dyn) {
            return bind(newSlot)(function (slot) {
                return subscribeDyn_(Control_Monad_Replace.replaceSlot(slot))(dyn);
            });
        };
    };
};
var unlessD = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var uniqDyn = Specular_FRP_Base.uniqDyn(dictMonadFRP)(Data_Eq.eqBoolean);
    var unless = Control_Applicative.unless(Monad0.Applicative0());
    return function (dictMonadReplace) {
        var dynamic_1 = dynamic_(dictMonadReplace)(dictMonadFRP);
        return function (dyn) {
            return function (block) {
                return bind(uniqDyn(dyn))(function (dyn$prime) {
                    return dynamic_1(mapFlipped(dyn$prime)(function (value) {
                        return unless(value)(block);
                    }));
                });
            };
        };
    };
};
var whenD = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var uniqDyn = Specular_FRP_Base.uniqDyn(dictMonadFRP)(Data_Eq.eqBoolean);
    var when = Control_Applicative.when(Monad0.Applicative0());
    return function (dictMonadReplace) {
        var dynamic_1 = dynamic_(dictMonadReplace)(dictMonadFRP);
        return function (dyn) {
            return function (block) {
                return bind(uniqDyn(dyn))(function (dyn$prime) {
                    return dynamic_1(mapFlipped(dyn$prime)(function (value) {
                        return when(value)(block);
                    }));
                });
            };
        };
    };
};
var whenJustD = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        var whenD1 = whenD(dictMonadFRP)(dictMonadReplace);
        var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
        var Monad0 = MonadCleanup1.Monad0();
        var Bind1 = Monad0.Bind1();
        var bind = Control_Bind.bind(Bind1);
        var MonadEffect0 = dictMonadFRP.MonadEffect0();
        var readDynamic = Specular_FRP_Base.readDynamic(MonadEffect0);
        var newDynamic = Specular_FRP_Base.newDynamic(MonadEffect0);
        var discard1 = discard(Bind1);
        var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(MonadEffect0)(MonadCleanup1);
        var pure = Control_Applicative.pure(Monad0.Applicative0());
        return function (dyn) {
            return function (widget) {
                return whenD1(map(Data_Maybe.isJust)(dyn))(bind(readDynamic(dyn))(function (dynVal) {
                    if (dynVal instanceof Data_Maybe.Just) {
                        return bind(newDynamic(dynVal.value0))(function (dyn$prime) {
                            return discard1(subscribeEvent_(dyn$prime.set)(Specular_FRP_Base.filterJustEvent(Specular_FRP_Base.changed(dyn))))(function () {
                                return widget(dyn$prime.dynamic);
                            });
                        });
                    };
                    if (dynVal instanceof Data_Maybe.Nothing) {
                        return pure(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Specular.FRP.Replaceable (line 28, column 5 - line 33, column 27): " + [ dynVal.constructor.name ]);
                }));
            };
        };
    };
};
var dynamic = function (dictMonadReplace) {
    var newSlot = Control_Monad_Replace.newSlot(dictMonadReplace);
    return function (dictMonadFRP) {
        var bind = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
        var subscribeDyn = Specular_FRP_Base.subscribeDyn(dictMonadFRP);
        return function (dyn) {
            return bind(newSlot)(function (slot) {
                return subscribeDyn(Control_Monad_Replace.replaceSlot(slot))(dyn);
            });
        };
    };
};
export {
    dynamic_,
    withDynamic_,
    dynamic,
    whenJustD,
    whenD,
    unlessD
};
